import { AnyAction } from "redux";
import { SET_EDIT_ROLE_REPORTS_LOADED } from "../actions/loadingEditRoleReports";

export const loadingEditRoleReports = (state = false, action: AnyAction) => {
  switch (action.type) {
    case SET_EDIT_ROLE_REPORTS_LOADED:
      return action.editRoleReportsLoaded;
    default:
      return state;
  }
};

export default loadingEditRoleReports;
